import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { IdService } from '../../shared/services/id.service';

@Component({
	selector: 'rbc-spinner',
	templateUrl: './spinner.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnDestroy {
	// Private Members
	id: string;

	// Input Parameters
	@Input() overlay: boolean = false;
	@Input() labelLoading: string = 'Content is loading';
	@Input() size: 'small' | 'large' = 'small';
	@Input() centered: true | false | 'top' | 'bottom' = false;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	calculateSpinnerClasses() {
		const classes = {};
		classes['spinner-large'] = this.size === 'large';
		classes['spinner-overlay'] = this.overlay;
		classes['spinner-centered'] = this.centered;
		classes['spinner-centered-top'] = this.centered === 'top';
		classes['spinner-centered-bottom'] = this.centered === 'bottom';
		return classes;
	}
}
